import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import ProtectedPages from "@/containers/index.vue";
import LoginScreen from "@/views/login.vue";
import SignUpScreen from "@/views/SignUp.vue";
import Songs from "@/views/Songs.vue";
import Index from "@/views/Index.vue";
import ForgotPasswordScreen from "@/views/ForgotPassword.vue";
import ResetPasswordScreen from "@/views/ResetPassword.vue";
import ProfileScreen from "@/views/Profile.vue";
import CreateCampaignScreen from "@/views/CreateCampaign.vue";
import CampaignSummaryScreen from "@/views/CampaignSummary.vue";
import WalletScreen from "@/views/Wallet.vue";
import OTPScreen from "@/views/OTP.vue";
import { AppGuard, LoginGuard } from "./router.guard";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: "/", name: "Index", component: Index },
  { path: "/login", name: "LoginScreen", component: LoginScreen, beforeEnter: LoginGuard },
  { path: "/forgot-password", name: "ForgotPasswordScreen", component: ForgotPasswordScreen, beforeEnter: LoginGuard },
  {
    path: "/reset-password/:hash",
    name: "ResetPasswordScreen",
    component: ResetPasswordScreen,
    beforeEnter: LoginGuard
  },
  { path: "/sign-up", name: "SignUpScreen", component: SignUpScreen, beforeEnter: LoginGuard },
  { path: "/otp/:hash", name: "OTPScreen", component: OTPScreen },
  {
    path: "/app",
    component: ProtectedPages,
    beforeEnter: AppGuard,
    name: "MainApp",
    children: [
      { path: "/app", name: "ProfileScreen", component: ProfileScreen },
      { path: "/app/create-campaign", name: "CreateCampaignScreen", component: CreateCampaignScreen },
      { path: "/app/campaigns/:campaignId", name: "CampaignSummaryScreen", component: CampaignSummaryScreen },
      { path: "/app/wallet", name: "WalletScreen", component: WalletScreen },
      { path: "/app/songs", name: "Songs", component: Songs }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
